import {Component, Input, OnInit} from '@angular/core';
import {IForWhomItem} from './for-whoom-item/for-whoom-item.component';

@Component({
    selector: 'app-for-whoom',
    templateUrl: './for-whoom.component.html',
    styleUrls: ['./for-whoom.component.scss']
})
export class ForWhoomComponent implements OnInit {
    items: IForWhomItem[] = null;
    @Input() type: 'default' | 'business'| 'ai' = 'default';
    description = '';

    constructor() {
    }

    ngOnInit(): void {
        const data = {
            default: [
                {
                    label: 'Чутливі до стресу',
                    alt: 'Image representing an individual prone to stress',
                    src: './assets/img/fh1_1x.webp',
                    m_src: './assets/img/fh1_1x.webp',
                    link: 'https://blog.anima.help/uk/intense-stress-friend-or-foe/'
                },
                {
                    label: 'В терапії',
                    src: 'assets/img/fh2_1x.webp',
                    m_src: 'assets/img/fh2_1x.webp',
                    alt: 'Image symbolizing a person in therapy going through recovery',
                    link: 'https://blog.anima.help/uk/helping-you-to-track-progress/'
                },
                {
                    label: 'Завзяті',
                    src: 'assets/img/fh3_1x.webp',
                    m_src: 'assets/img/fh3_1x.webp',
                    alt: 'Image illustrating a high-performer, focusing on achievement and excellence',
                    link: 'https://blog.anima.help/uk/trauma-may-be-closer-than-you-think/'

                },
                {
                    label: 'Терапевти',
                    src: 'assets/img/fh4_1x.webp',
                    m_src: 'assets/img/fh4_1x.webp',
                    alt: 'Image of a therapist, in a counseling setting, emphasizing professionalism and care in mental health.',
                    link: 'https://blog.anima.help/uk/how-to-measure-the-effectiveness-of-the-therapy/'

                }
            ],
            business: [
                {
                    label: 'Управлінці',
                    alt: 'Image representing an individual prone to stress',
                    src: './assets/img/for_whoom/management.webp',
                    m_src: './assets/img/for_whoom/management.webp',
                    link: 'https://blog.anima.help/uk/%d1%80%d0%be%d0%bb%d1%8c-ceo-%d1%83-%d0%bc%d0%b5%d0%bd%d1%82%d0%b0%d0%bb%d1%8c%d0%bd%d0%be%d0%bc%d1%83-%d0%b4%d0%be%d0%b1%d1%80%d0%be%d0%b1%d1%83%d1%82%d1%96-%d0%ba%d0%be%d0%bc%d0%b0%d0%bd%d0%b4%d0%b8/'
                },
                {
                    label: 'Human resources',
                    src: './assets/img/for_whoom/hr.webp',
                    m_src: './assets/img/for_whoom/hr.webp',
                    alt: 'Image symbolizing a person in therapy going through recovery',
                    link: 'https://blog.anima.help/uk/anima-%d0%b4%d0%bb%d1%8f-hr-%d0%bd%d0%be%d0%b2%d0%b8%d0%b9-%d0%b2%d0%b8%d0%bc%d1%96%d1%80-%d1%82%d1%83%d1%80%d0%b1%d0%be%d1%82%d0%b8-%d0%bf%d1%80%d0%be-%d0%b4%d0%be%d0%b1%d1%80%d0%be%d0%b1%d1%83/'
                },
                {
                    label: 'Психологи',
                    src: './assets/img/for_whoom/psy.webp',
                    m_src: './assets/img/for_whoom/psy.webp',
                    alt: 'Image illustrating a high-performer, focusing on achievement and excellence',
                    link: 'https://blog.anima.help/uk/%d1%80%d0%be%d0%b7%d1%83%d0%bc%d0%bd%d1%96-%d1%96%d0%bd%d1%81%d1%82%d1%80%d1%83%d0%bc%d0%b5%d0%bd%d1%82%d0%b8-%d0%b4%d0%bb%d1%8f-%d0%bf%d1%81%d0%b8%d1%85%d0%be%d0%bb%d0%be%d0%b3%d1%96%d0%b2-%d0%b5/'

                },
                {
                    label: 'Робітники',
                    src: './assets/img/for_whoom/employees.webp',
                    m_src: './assets/img/for_whoom/employees.webp',
                    alt: 'Image of a therapist, in a counseling setting, emphasizing professionalism and care in mental health.',
                    link: 'https://blog.anima.help/uk/%d0%bf%d1%96%d0%ba%d0%bb%d1%83%d0%b9%d1%82%d0%b5%d1%81%d1%8c-%d0%bf%d1%80%d0%be-%d1%81%d0%b2%d1%96%d0%b9-%d0%b4%d0%be%d0%b1%d1%80%d0%be%d0%b1%d1%83%d1%82-%d0%bd%d0%b0-%d1%80%d0%be%d0%b1%d0%be%d1%82/'

                }
            ],
            ai: [
                {
                    label: 'Управлінці',
                    alt: 'Image representing an individual prone to stress',
                    src: './assets/img/for_whoom/management.webp',
                    m_src: './assets/img/for_whoom/management.webp',
                    link: 'https://blog.anima.help/uk/%d1%80%d0%be%d0%bb%d1%8c-ceo-%d1%83-%d0%bc%d0%b5%d0%bd%d1%82%d0%b0%d0%bb%d1%8c%d0%bd%d0%be%d0%bc%d1%83-%d0%b4%d0%be%d0%b1%d1%80%d0%be%d0%b1%d1%83%d1%82%d1%96-%d0%ba%d0%be%d0%bc%d0%b0%d0%bd%d0%b4%d0%b8/'
                },
                {
                    label: 'Human resources',
                    src: './assets/img/for_whoom/hr.webp',
                    m_src: './assets/img/for_whoom/hr.webp',
                    alt: 'Image symbolizing a person in therapy going through recovery',
                    link: 'https://blog.anima.help/uk/anima-%d0%b4%d0%bb%d1%8f-hr-%d0%bd%d0%be%d0%b2%d0%b8%d0%b9-%d0%b2%d0%b8%d0%bc%d1%96%d1%80-%d1%82%d1%83%d1%80%d0%b1%d0%be%d1%82%d0%b8-%d0%bf%d1%80%d0%be-%d0%b4%d0%be%d0%b1%d1%80%d0%be%d0%b1%d1%83/'
                },
                {
                    label: 'Психологи',
                    src: './assets/img/for_whoom/psy.webp',
                    m_src: './assets/img/for_whoom/psy.webp',
                    alt: 'Image illustrating a high-performer, focusing on achievement and excellence',
                    link: 'https://blog.anima.help/uk/%d1%80%d0%be%d0%b7%d1%83%d0%bc%d0%bd%d1%96-%d1%96%d0%bd%d1%81%d1%82%d1%80%d1%83%d0%bc%d0%b5%d0%bd%d1%82%d0%b8-%d0%b4%d0%bb%d1%8f-%d0%bf%d1%81%d0%b8%d1%85%d0%be%d0%bb%d0%be%d0%b3%d1%96%d0%b2-%d0%b5/'

                },
                {
                    label: 'Робітники',
                    src: './assets/img/for_whoom/employees.webp',
                    m_src: './assets/img/for_whoom/employees.webp',
                    alt: 'Image of a therapist, in a counseling setting, emphasizing professionalism and care in mental health.',
                    link: 'https://blog.anima.help/uk/%d0%bf%d1%96%d0%ba%d0%bb%d1%83%d0%b9%d1%82%d0%b5%d1%81%d1%8c-%d0%bf%d1%80%d0%be-%d1%81%d0%b2%d1%96%d0%b9-%d0%b4%d0%be%d0%b1%d1%80%d0%be%d0%b1%d1%83%d1%82-%d0%bd%d0%b0-%d1%80%d0%be%d0%b1%d0%be%d1%82/'

                }
            ]
        };

        const descriptions = {
            default: 'Наш тест пропонує глибоку оцінку вашого психоемоційного стану, надаючи персоналізований аналіз. Відмінно підходить для тих, хто хоче краще зрозуміти себе. Anima буде корисною, якщо ви:',
            business: 'Наш тест дає всебічне уявлення про психічне здоров’я працівників, пропонуючи персоналізовані рекомендації, що допомагають компаніям створювати здоровіший та більш продуктивний робочий колектив. Ідеально підходить для організацій будь-якого розміру. Anima буде корисною, якщо ви:',
            ai: 'Якщо ви відчуваєте перевантаження, тривожні чи депресивні симптоми, або просто хочете краще зрозуміти свій внутрішній стан — АІ-асистент Anima пропонує науково обґрунтовані рекомендації, адаптовані під унікальні особливості вашої психіки:'
        };
        this.description = descriptions[this.type];
        this.items = data[this.type];
    }
}
